import React from 'react';
import PublicLayoutPage from '../components-app/PublicPageLayout';
import '../styles/redirect.scss';
import store from 'store';
import {Header,Footer,Step,LoadGraphic} from '../components-static/Common';
import qs from 'query-string';

/**
 * How to write a redirect
 * 
 * Mandatory
 *  location - /location, only visible page to a temp user
 * 
 * Option
 *  q - query behind location
 * 
 *  tags - searchable tags, only accept @ without bracket
 *  
 *  Between queries, use ~
 *  Replace key=value with key:value
 *  
 */
export default class RedirectList extends React.Component{

    state={
        step:"loading",
    };

    componentDidMount=()=>{
        this.processLink();
    };

    processLink=()=>{

        try{
            const query = qs.parse(this.props.location.search);
            const location = query.location
            const targetList = location.substr(1).replace("-","");
            const tagList = query.tags;
            const tagsArray = tagList.split("~");

            let tags = "";
            for(var i=0; i<tagsArray.length; i++){
                const currentTag = tagsArray[i].split(":");
                tags+= ((i==0)?"":"~") + "@"+currentTag[0] + "(" + currentTag[1] + ")";
            }
            console.log(targetList);
            console.log(tags);

            let tempQuery = "";
            if(query.q){
                let queries = query.q.split("~");
                for(var i=0; i<queries.length; i++){
                    const qR = queries[i].replace(":","=");
                    tempQuery += ((i==0) ? "?" : "&") + qR;
                }
            }

            store.set(targetList,tags);
            window.location = location+tempQuery;
        }
        catch(error){
            this.setState({step:"error",error:"Invalid Link Provided"});
            throw(error);
        }
    };

    render(){
        return(
            <PublicLayoutPage>
                <div style={{textAlign:"center"}}>
                    <div className="redirect-container">
                        <Step active={(this.state.step == "loading")}>
                            <LoadGraphic active={true} text="Redirecting..."/>
                        </Step>
                        <Step active={(this.state.step == "error")}>
                            <h1>{this.state.error}</h1>
                            <div>This page is only accessible through a Smartdorm link, provided via Email</div>
                        </Step>
                    </div>
                </div>
            </PublicLayoutPage>
        );
    }
};